import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Slider from 'react-slick'

import media from '../../../services/generateMediaQueries'

const DotContainer = styled.div`
  display: flex;
  align-items: center;
`

const Dot = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.5rem;
  background: #ffffff;
  opacity: 0.5;

  transition: all var(--animation-duration) var(--animation-easing);
`

const StyledSlider = styled(Slider)`

  > .slick-list {
    overflow: visible;

    > .slick-track {
      display: flex;
    }
      ${props =>
        props.loading &&
        props.centerMode &&
        css`
          > .slick-track {
            transform: translateX(-3605px);
          }
        `}
      ${props =>
        props.contentLength === 1 &&
        css`
          width: 100%;
          max-width: 1024px;
          margin: 0 auto;

          > .slick-track {
            justify-content: center;
          }
        `}
      ${props =>
        props.centerMode &&
        css`
          ${media.greaterThan('medium')`
          * > .slick-slide {
            opacity: 0.5;
          }

          * > .slick-current {
            opacity: 1;
          }
        `}
          * > .slick-slide,
        .slick-current {
            transition: all var(--animation-duration) var(--animation-easing);
          }
        `};
  }

  > .slick-dots {
    position: unset;
    bottom: unset;
    padding: 0;
    margin-top: 1.5rem;

    .slick-active {
      ${Dot} {
        opacity: 1;
        width: 2rem;
      }
    }

    ${({ variant }) =>
      variant === 'small' &&
      `
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;

    ${Dot} {
      background: var(--color-fg-lighter);
      opacity: 1;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 0.25rem;
    }

    .slick-active {
      ${Dot} {
        background-color: var(--color-accent-4);
        width: 0.25rem;
        height: 0.25rem;
        border-radius: 0.25rem;
      }
    }
    `}

    > li {
      position: unset;
      width: unset;
      height: unset;
      margin: 0 2.5px;

      .active {
        color: white;
      }

      > button {
        &:before {
          color: white;
        }
      }
    }
  }
`

const TopPicksBannerContainer = styled.div`
  position: absolute;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  height: 400px;
  left: 0;
  right: 0;
`

const BannerTransformHelper = styled.div`
  position: absolute;
  width: 127px;
  height: 127px;
  top: -0.75rem;
  left: -0.75rem;
  overflow: hidden;
`

const TopPicksBanner = styled.div`
  position: absolute;
  z-index: 1;
  background: var(--color-primary);
  padding: 0.5rem 1rem;
  color: white;
  font-family: var(--font-family-ayala-display-sans);
  font-size: 0.875rem;
  font-weight: var(--font-weight-boldest);
  text-align: center;
  width: 200px;
  transform: rotate(-45deg);
  top: 32px;
  left: -50px;
`

const BannerOuter = styled.div`
  &:before,
  &:after {
    content: ' ';
    position: absolute;
  }

  &:before {
    background: linear-gradient(to bottom, #06605f 0%, transparent 30%);
    width: 2.5rem;
    height: 150px;
    right: 0;
  }

  &:after {
    background: linear-gradient(to right, #06605f 0%, transparent 30%);
    width: 150px;
    height: 2.5rem;
    bottom: 0;
  }
`

const StyledLink = styled.a`
  margin-left: 1.5rem;
  font-size: 0.875rem;
  font-weight: var(--font-weight-boldest);
  color: #ffffff !important;
  text-decoration: none;

  ${media.lessThan('medium')`
    display: none;
  `}
`

const mediumWidth = 991

class CardSlider extends React.Component {
  state = {
    client: false,
    width: 1440,
  }

  componentDidMount() {
    this.setState({
      client: true,
      width: this.getWidth(),
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { width } = prevState
    const newWidth = this.getWidth()
    if (width !== newWidth) this.setState({ width: newWidth })
  }

  getInitialSlide = propsInitial => {
    if (this.state.width <= mediumWidth) return 0
    if (typeof propsInitial == 'number') return propsInitial
    return 0
  }

  getSettings = (client, featured, bannerAds) => {
    if (featured)
      return {
        centerMode: true,
        infinite: true,
        dots: true,
        responsive: client && [
          {
            breakpoint: 991.98,
            settings: {
              infinite: false,
              centerMode: false,
            },
          },
        ],
      }
    if (bannerAds)
      return {
        centerMode: true,
        dots: true,
      }
    return {}
  }

  getWidth = () => {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth,
    )
  }

  render() {
    const {
      dataSource,
      renderItem,
      parentRef,
      dots,
      featured,
      bannerAds,
      onViewAllClick,
      loadingComponent: LoadingComponent,
      initialSlide,
      loading,
      ...restProps
    } = this.props

    const { client } = this.state

    const isEmpty = !dataSource.length

    const settings = this.getSettings(client, featured, bannerAds)
    const thisInitialSlide = this.getInitialSlide(initialSlide)

    return (
      <>
        {featured && (
          <TopPicksBannerContainer>
            <BannerTransformHelper>
              <TopPicksBanner>Top Picks</TopPicksBanner>
              <BannerOuter />
            </BannerTransformHelper>
          </TopPicksBannerContainer>
        )}

        <StyledSlider
          key={client ? 'client' : 'server'}
          // initialSlide={typeof initialSlide == 'number' ? initialSlide : 0}
          initialSlide={thisInitialSlide}
          infinite={false}
          variableWidth
          dots={dots}
          focusOnSelect
          draggable
          ref={parentRef}
          arrows={false}
          easing="ease"
          contentLength={dataSource.length}
          loading={isEmpty}
          variant={bannerAds && 'small'}
          customPaging={i => {
            if (!featured && !bannerAds) {
              return false
            }

            return (
              <DotContainer>
                <Dot />
                {!bannerAds && i + 1 === dataSource.length && (
                  <StyledLink
                    onClick={e => {
                      e.stopPropagation()
                      if (onViewAllClick) {
                        onViewAllClick()
                      }
                    }}
                  >
                    View all
                  </StyledLink>
                )}
              </DotContainer>
            )
          }}
          {...settings}
          {...restProps}
        >
          {(isEmpty || loading) &&
            LoadingComponent &&
            Array(3)
              .fill(null)
              .map((val, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <LoadingComponent key={`loading-${index}`} />
              ))}
          {renderItem && !loading && dataSource.map(renderItem)}
        </StyledSlider>
      </>
    )
  }
}

CardSlider.defaultProps = {
  renderItem: item => <div key={item}>{item}</div>,
  dots: false,
}

CardSlider.propTypes = {
  dots: PropTypes.bool,
  dataSource: PropTypes.array,
  renderItem: PropTypes.func,
}

export default React.forwardRef((props, ref) => (
  <CardSlider parentRef={ref} {...props} />
))
